import {
  Box,
  Stack,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SearchTermTabskeleton = () => {
  const theme = useTheme();
  const rows = Array.from({ length: 5 });
  return (
    <Box p={2}>
      {/* Header */}
      <Stack spacing={0.5} sx={{ mb: 2 }}>
        <Skeleton
          variant="text"
          width={160}
          height={30}
          sx={{ borderRadius: 1 }}
        />
        <Skeleton
          variant="text"
          width="70%"
          height={18}
          sx={{ borderRadius: 1 }}
        />
      </Stack>

      {/* Card Wrapper */}
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 1.5,
          boxShadow: theme.shadows[1],
          overflow: "hidden",
        }}
      >
        {rows.map((_, i) => (
          <Accordion
            key={i}
            disabled
            elevation={0}
            sx={{
              "&:before": { display: "none" },
              backgroundColor: "transparent",
              "& .MuiAccordionSummary-root": {
                minHeight: 48,
                px: 2,
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionDetails-root": {
                p: 0,
              },
              borderBottom:
                i < rows.length - 1
                  ? `1px solid ${theme.palette.divider}`
                  : "none",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon color="disabled" />}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ width: "100%" }}
              >
                <Skeleton
                  variant="text"
                  width="38%"
                  height={22}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="text"
                  width="48%"
                  height={18}
                  sx={{ borderRadius: 1 }}
                />
              </Stack>
            </AccordionSummary>

            <AccordionDetails>
              <Box px={2} py={1}>
                <Skeleton variant="rectangular" width="100%" height={50} />
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default SearchTermTabskeleton;
